
import { Component, inject, OnDestroy, OnInit } from '@angular/core';

import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractDialog, AbstractDialogResultData, AbstractFormDialog, FormDialogComponent } from '@next/core-lib/dialog';
import { SiteState } from '@next/core-lib/site';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';

import { takeUntil } from 'rxjs/operators';

import { OrganicMatterReport, OrganicMatterTable } from '../../organic-matter-balance.models';
import { OrganicMatterReportDialogModel } from './organic-matter-report-dialog.model';

import { AsyncPipe, DecimalPipe } from '@angular/common';
// eslint-disable-next-line max-len
import { MatCell, MatCellDef, MatColumnDef, MatFooterCell, MatFooterCellDef, MatFooterRow, MatFooterRowDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable } from '@angular/material/table';
import { TranslatePipe } from '@next/core-lib/i18n';
import { selectOrganicMatterTableReport } from '../../store/organic-matter-balance.selectors';


@Component({
  selector: 'app-organic-matter-report-dialog',
  templateUrl: './organic-matter-report-dialog.component.html',
  styleUrls: ['organic-matter-report-dialog.component.scss'],
  imports: [
    FormDialogComponent,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatFooterCellDef,
    MatFooterCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatFooterRowDef,
    MatFooterRow,
    AsyncPipe,
    DecimalPipe,
    TranslatePipe,
  ],
})
export class OrganicMatterReportDialogComponent
  extends AbstractFormDialog<OrganicMatterReport>
  implements OnInit, OnDestroy {
  data = inject<OrganicMatterReportDialogModel>(MAT_DIALOG_DATA);
  protected mdDialogRef = inject<MatDialogRef<AbstractDialog<OrganicMatterReport>, AbstractDialogResultData<OrganicMatterReport>>>(MatDialogRef);
  private readonly fb = inject(FormBuilder);
  private readonly store = inject<Store<SiteState>>(Store);

  formGroup = this.fb.group({ report: this.data.report });
  tableReportData$: Observable<OrganicMatterTable[]> = new Observable();
  sortedTableData$: Observable<OrganicMatterTable[]> = new Observable();
  displayedColumns = ['name', 'total', 'perHectare'];
  private readonly destroyed$ = new Subject<void>();

  get organicMatterBalance(): OrganicMatterReport {
    return this.formGroup.get('report')?.value as OrganicMatterReport;
  }

  ngOnInit(): void {
    this.tableReportData$ = this.store.pipe(
      select(selectOrganicMatterTableReport),
      takeUntil(this.destroyed$),
    );
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }
}
